export default "__VITE_ASSET__a592d945__"